export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarItem.vue?vue&type=template&id=96fcd4f2&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/SidebarPlugin/SidebarItem.vue?vue&type=template&id=96fcd4f2&scoped=true
// module id = 1460
// module chunks = 31